export const forHeader =  [{
  type: "HEADER",
  format:  'NONE',
  text: '',
  // example: {
  //   header_text: []
  // }
}]

export const forBody =   [{
  type:"text",
  format:"BODY",
  text: '',
  // example: {
  //   body_text: [[]]
  // }
}]

export const forFooter = [{
  type: "text",
  format: "FOOTER",
  text: ''
}]

export const forButton =[
  {
    type: "BUTTONS",
    text: "",
    buttonType: 'CTA',
    url: "",
    buttons: []
  },
  {
    type: "BUTTONS",
    text: "",
    buttonType: 'QUICK_REPLY',
    url: "",
    buttons: []
  },
]